import { useCallback, useEffect, useState } from 'react'

import {
  LoadingText,
  PlayerContainer,
  PlayerSectionContainer
} from '@/components/Player/Player.styles'
import { getStreamData } from '@/service/streamService'
import { Stream } from '@/types/streams/stream'
import getResponseErrorMessage from '@/utils/_legacy/getResponseErrorMessage'
import { notifyError } from '@/utils/notifyError'

import ReactPlayer from '../_legacy/ReactPlayer'

const Player = ({
  eventId,
  streamingConfigId,
  posterUrl
}: {
  eventId: string
  streamingConfigId?: number
  posterUrl: string | null
}) => {
  const [stream, setStream] = useState<Stream | null>(null)

  const fetchStream = useCallback(async () => {
    if (streamingConfigId) {
      try {
        const streamData = await getStreamData(eventId, String(streamingConfigId))

        setStream(streamData || null)
      } catch (error) {
        notifyError(`Error: ${getResponseErrorMessage(error)}`)
      }
    }
  }, [eventId, streamingConfigId])

  useEffect(() => {
    fetchStream()
  }, [eventId, fetchStream, streamingConfigId])

  if (!stream) {
    return (
      <PlayerSectionContainer>
        <PlayerContainer>
          {posterUrl ? (
            <img alt="Thumbnail" src={posterUrl} style={{ objectFit: 'contain' }} />
          ) : null}
          {streamingConfigId ? <LoadingText>Loading...</LoadingText> : null}
        </PlayerContainer>
      </PlayerSectionContainer>
    )
  }

  return (
    <PlayerSectionContainer>
      <PlayerContainer>
        <ReactPlayer
          style={{ position: 'absolute', top: 0, left: 0 }}
          url={stream.hlsUrl}
          controls={true}
          muted={true}
          config={{ file: { attributes: { autoPlay: true } } }}
          width="100%"
          height="100%"
        />
      </PlayerContainer>
    </PlayerSectionContainer>
  )
}

export default Player
